import React from 'react';
import { Button, Tabs, message } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { CollectionServer, GetMetaProperties, SetMetaProperties, Model, POST, QueryDetail, QueryOrder, errorCatch, getObjectDisplay, updateInPropertiesUUID, updateInArray, useAuth, useMetaContext, deleteInProperties, contextFilterToObject, foreachInProperties, useClipboardContext, clean } from 'fennec-ui'
import PageLayout from '../../components/PageLayout';
import MDEditor, { commands, EditorContext } from "@uiw/react-md-editor";
import rehypeSanitize from "rehype-sanitize";
import { goTo } from '../../../common/Tool';
import User from '../../../common/User';
import ObjectOwnerDescription from '../../../fedance-ui/ObjectOwnerDescription';
import { FunctionOutlined, InfoCircleOutlined, InfoOutlined } from '@ant-design/icons';
import CopyToClipboard from 'react-copy-to-clipboard';
import translit from 'cyrillic-to-translit-js/CyrillicToTranslit'

var _ = require('lodash');
const { TabPane } = Tabs;

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

export default function FederationadministratorSettingsPostTemplates(props) {
    const auth = useAuth()
    const meta = useMetaContext()

    const filtersFromMeta = React.useCallback((name) => {
        let prop = [];
        let p = _.get(meta[name], "properties");
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;

        if (!obj) { return obj }
        let p = GetMetaProperties(obj)

        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt"])

        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }

        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }

        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        p = foreachInProperties(p, n => {
            return (n.type == "object" && n.name != "TipParametraPostov")
        }, {
            queryFilter: [
                QueryDetail("model"),
                QueryOrder("ID", "ASC"),
            ],
            dropdownActions: (value, item, meta, contextObject) => {
                let name = item?.relation?.reference?.object;
                let m = meta[name]

                return [{
                    title: "Создать",
                    form: Model,

                    object: {},

                    // links: true,
                    // links: "inline",
                    // modelActions: (item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                    //     return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
                    // },
                    // collectionActions: ({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                    //     return actions.map(e => ({ ...e, meta: cleanProperties(mobject, {name, field, fieldName, contextObject}) }))
                    // },

                    meta: cleanProperties(m, { ...context, contextObject: contextObject }),
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        POST(auth, `/api/query-create/${name}`, { ...values },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                },
                ]
            }
        })

        p = foreachInProperties(p, n => {
            return (n.type == "object" && n.name == "TpDataSchemeSourcesScheme")
        }, (n) => {
            return {
                relation: {
                    ...n?.relation,
                    uiFilter: () => filtersFromMeta("TpDataSchemeSources")?.map(e => (e?.name == "Sort" ? { ...e, sorted: "ASC" } : e)),
                    display: (item) => {
                        console.log(item)
                        return (
                            <div>

                                {item?.sort} {(item?.source?.tpDataSourceTypeID == 2) ?
                                    (<CopyToClipboard text={
                                        item?.source?.func + "\r\n" + translit().transform((item?.source?.func || "").replace(/_([a-zа-я])/g, ($1) => { return $1.toUpperCase(); }).replace(/_/g, '').replace(/\-/g, '').trim().replace(/  /g, ' '), "_")
                                            .replace(/ /g, "")
                                            .replace(/\./g, "")}
                                        onCopy={(text) => message.success("Скопировано: " + text || "")}>
                                        <span style={{ color: "darkmagenta", cursor: "pointer" }} title={"Источник: функция " + item?.source?.func}><FunctionOutlined /></span>
                                    </CopyToClipboard>) :
                                    (<span style={{ color: "#6a6a6a" }} title="Источник: таблица дополнительной информации"><InfoCircleOutlined /></span>)} - {item?.source?.tpKey?.opisanie} - {item?.source?.tpRole?.nazvanie}
                            </div>

                        )
                    },
                },
            }
        })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "User"), {
            mode: "dialog",
            relation: {
                uiFilter: () => [
                    {
                        name: "lastname",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "firstname",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "patronymic",
                        sort: true,
                        filter: true,
                    },

                    {
                        name: "email",
                        sort: true,
                        filter: true,
                    },
                    {
                        label: "Телефон",
                        name: "phone",
                        sort: true,
                        filter: true,
                    },
                    {
                        name: "gender",
                        sort: true,
                        filter: true,
                        display: (o) => o.name,
                    },
                    {
                        label: "Дата создания",
                        name: "createdAt",
                        type: "date",
                        sort: true,
                        filter: true,
                    },
                ],
                displayString: (item) => {
                    return item?.lastname + " " + item?.firstname
                },
                display: (item) => {
                    return (
                        <User item={item} />
                    )
                },
                reference: { object: "User", property: "ID" },
                type: "many-one",
            },
            dropdownActions: undefined,
            queryFilter: [
                QueryDetail("combobox"),
                QueryOrder("firstname", "ASC")
            ]
        })

        p = foreachInProperties(p, n => (n.type == "string" && !n?.db?.size), {
            type: "func",
            render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                return (<MDEditor
                    data-color-mode="light"
                    value={value} onChange={onChange}
                    preview={"edit"}
                    overflow={false}
                />)
            }
        })

        return SetMetaProperties(obj, p)
    }

    const [clipboard, setClipboard] = useClipboardContext()
    return (
        <PageLayout>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
                <Tabs defaultActiveKey="system-attestation">
                    <TabPane key="tp_data_scheme" tab={"Схемы"}>
                        <CollectionServer
                            auth={auth}
                            name={"TpDataScheme"}
                            queryDetail={"model"}
                            filters={() => filtersFromMeta("TpDataScheme")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "TpDataScheme", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}


                            linksModelActions={"inline"}
                            scheme={[
                                "TpDataSchemeSourcesScheme",
                            ]}

                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                if (name === "TpDataScheme") {
                                    let _act = actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }));
                                    return _act
                                }
                                return actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                            }}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                let funcs = []
                                let ac = actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject }, funcs) }))
                                return ac
                            }}
                        />
                    </TabPane>
                    <TabPane key="tp_data_scheme_sources" tab={"Источники схемы"}>
                        <CollectionServer
                            auth={auth}
                            name={"TpDataSchemeSources"}
                            queryDetail={"model"}
                            filters={() => filtersFromMeta("TpDataSchemeSources")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "TpDataSchemeSources", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}


                            linksModelActions={"inline"}
                            scheme={[]}

                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                if (name === "TpDataSchemeSources") {
                                    let _act = actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }));
                                    return _act
                                }
                                return actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                            }}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                let funcs = []
                                let ac = actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject }, funcs) }))
                                return ac
                            }}
                        />
                    </TabPane>
                    <TabPane key="tp_data_source" tab={"Источники данных"}>
                        <CollectionServer
                            auth={auth}
                            name={"TpDataSource"}
                            queryDetail={"model"}
                            filters={() => filtersFromMeta("TpDataSource")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "TpDataSource", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={"inline"}
                            scheme={[]}

                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                if (name === "TpDataSource") {
                                    let _act = actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }));
                                    return _act
                                }
                                return actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                            }}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                let funcs = []

                                let ac = actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject }, funcs) }))
                                return ac
                            }}
                        />
                    </TabPane>
                    <TabPane key="tp_keys" tab={"Ключи дополнительной информации"}>
                        <CollectionServer
                            auth={auth}
                            name={"TpKeys"}
                            queryDetail={"model"}
                            filters={() => filtersFromMeta("TpKeys")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "TpKeys", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={"inline"}
                            scheme={[]}

                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                if (name === "TpKeys") {
                                    let _act = actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }));
                                    return _act
                                }
                                return actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                            }}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                let funcs = []
                                let ac = actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject }, funcs) }))
                                return ac
                            }}
                        />
                    </TabPane>
                    <TabPane key="tp_roles" tab={"Роли"}>
                        <CollectionServer
                            auth={auth}
                            name={"TpRoles"}
                            queryDetail={"model"}
                            filters={() => filtersFromMeta("TpRoles")}

                            mode="list"
                            render={(item, idx) => (
                                <div style={{ padding: "0px 5px" }}>
                                    <div>{getObjectDisplay(item, "TpRoles", meta)}</div>
                                    <div style={{ color: "#6a6a6a" }}></div>
                                </div>
                            )}

                            linksModelActions={"inline"}
                            scheme={[]}

                            modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                if (name === "TpRoles") {
                                    let _act = actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }));
                                    return _act
                                }
                                return actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                            }}
                            collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                                let funcs = []
                                let ac = actions.map(e => ({ ...e, queryDetail: "model", meta: cleanProperties(mobject, { name, field, fieldName, contextObject }, funcs) }))
                                return ac
                            }}
                        />
                    </TabPane>
                </Tabs>
            </div>
        </PageLayout >
    );
}